
const axios = require("axios");


const Proof = {

  async get(collectionId, proofGroupId, tokenId){
        const options = {
            url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}/proofGroup/${proofGroupId}/proof/${tokenId}`,
            baseURL: window.ProveAnything.config.functionUrl,
            method: "get",
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "json",
          };
      
          try {
            const response = await axios(options);
            const json = response.data;
      
            return json;
          } catch (error) {
            return error
          }
    },

    async getProofs(params){

      let url = `${window.ProveAnything.config.functionAuthPath}/collection/${params.collectionId}/proofs`
      if (params.proofGroupId){
        url = `${window.ProveAnything.config.functionAuthPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proofs`
      }

      const options = {
        url: url,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "json",
      };

      try {
        const response = await axios(options);
        const json = response.data;

        return json;
      } catch (error) {
        return []
      }  
  },

  // update some metadata for a token - you must have the rights to do this  
  async updateMeta(params) {

    const options = {
      url: `${window.ProveAnything.config.functionPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proof/${params.tokenId}/meta`,
      baseURL: window.ProveAnything.config.functionUrl,
      method: "put",
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(params.data),
      responseType: "json",
    };

    try {
      const response = await axios(options);
      const json = response.data;

      return json;
    } catch (error) {
      return error
    }
  },
  // update some metadata for a token - you must have the rights to do this  
  async updateRoles(params) {

    const options = {
      url: `${window.ProveAnything.config.functionPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proof/${params.tokenId}/roles`,
      baseURL: window.ProveAnything.config.functionUrl,
      method: "put",
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(params.data),
      responseType: "json",
    };

    try {
      const response = await axios(options);
      const json = response.data;

      return json;
    } catch (error) {
      return error
    }
  },

  async getDocuments(collectionId, proofGroupId, tokenId){
    const options = {
        url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}/proofGroup/${proofGroupId}/proof/${tokenId}/document`,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json",
      };
  
      try {
        const response = await axios(options);
        const json = response.data;
  
        return json;
      } catch (error) {
        return error
      }
  },


    // update a document on a token
    async updateDocument(params) {

      const options = {
        url: `${window.ProveAnything.config.functionPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proof/${params.tokenId}/document/${params.documentId}`,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(params.data),
        responseType: "json",
      };

      try {
        const response = await axios(options);
        const json = response.data;

        return json;
      } catch (error) {
        return error
      }
    },

    
    // delete a document on a token
    async deleteDocument(params) {

      const options = {
        url: `${window.ProveAnything.config.functionPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proof/${params.tokenId}/document/${params.documentId}`,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "delete",
        responseType: "json",
      };

      try {
        const response = await axios(options);
        const json = response.data;

        return json;
      } catch (error) {
        return error
      }
    },

     
    // add a document to a token
    async addDocument(params) {

      const options = {
        url: `${window.ProveAnything.config.functionPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proof/${params.tokenId}/document`,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(params.data),
        responseType: "json",
      };

      try {
        const response = await axios(options);
        const json = response.data;

        return json;
      } catch (error) {
        return error
      }
    },

  async refresh(params){

    const options = {
      url: `${window.ProveAnything.config.functionAuthPath}/collection/${params.collectionId}/proofGroup/${params.proofGroupId}/proofs/refresh`,
        baseURL: window.ProveAnything.config.functionUrl,
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json",
      };
  
      try {
        const response = await axios(options);
        const json = response.data;
  
        return json;
      } catch (error) {
        return error
      }
}  
}

export default Proof;
